import { Monitor, Smartphone, Megaphone, Cpu } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Tag } from "@/components/portfolio/Reveal";

const ICONS = { monitor: Monitor, smartphone: Smartphone, megaphone: Megaphone, cpu: Cpu };

export const Services = () => {
  const { t } = useLang();
  const s = t.services;
  return (
    <section id="services" data-testid="services-section" className="bg-paper py-24 md:py-32">
      <div className="max-w-[88rem] mx-auto px-5 md:px-10">
        <Reveal className="flex flex-col items-center text-center gap-5 mb-16 md:mb-20">
          <Tag>{s.tag}</Tag>
          <h2 className="font-extrabold text-ink text-4xl md:text-5xl tracking-tight">{s.title}</h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
          {s.items.map((item, i) => {
            const Icon = ICONS[item.icon] || Monitor;
            return (
              <Reveal key={i} delay={i * 0.08}>
                <div className="group h-full rounded-2xl p-7 border border-black/[0.07] hover:border-brand hover:shadow-xl hover:shadow-brand/10 transition-all duration-400 bg-white">
                  <div className="h-14 w-14 rounded-xl bg-brand/20 flex items-center justify-center mb-6 group-hover:bg-brand transition-colors duration-300">
                    <Icon size={26} className="text-ink" />
                  </div>
                  <h3 className="font-bold text-lg text-ink leading-snug mb-3">{item.title}</h3>
                  <p className="font-normal text-sm text-ink/60 leading-relaxed">{item.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
